import { getAuthData } from '@/shared/utils/auth';
import axios from 'axios';

export const httpClient = axios.create({
	baseURL: import.meta.env.VITE_BASE_API_URL as string,
	headers: { 'Content-Type': 'application/json' },
});

httpClient.interceptors.request.use((config) => {
	const requestConfig = { ...config };
	const accessToken = getAuthData()?.accessToken;
	if (accessToken) {
		requestConfig.headers.Authorization = `Bearer ${accessToken}`;
	}

	return requestConfig;
});
